// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  position: relative;
  width: 100%;
  min-height: 80vh;
  min-height: 80dvh;
  overflow: hidden;
  color: #fff;
}

.hero__backdrop {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.hero__bg-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero__gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

.hero__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 80vh;
  min-height: 80dvh;
  max-width: 1920px;
  margin: 0 auto;
  padding: 56px 56px 48px;
  box-sizing: border-box;
}

.hero__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 48px;
}

.hero__copy {
  flex: 1 1;
  min-width: 0;
  max-width: 722px;
  padding-left: 0;
}

.hero__title {
  margin: 0 0 32px;
  font-family: 'Averia Serif Libre', Georgia, serif;
  font-size: clamp(2.5rem, 3.75vw, 4.5rem);
  font-weight: 400;
  line-height: 1.15;
  letter-spacing: -0.02em;
  color: #fff;
}

.hero__subtitle {
  margin: 0 0 40px;
  max-width: 580px;
  font-family: 'Inter', system-ui, sans-serif;
  font-size: clamp(1rem, 1.25vw, 1.5rem);
  font-weight: 500;
  line-height: 1.35;
  color: #fff;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.5);
}

.hero__stores {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.hero__qr {
  flex-shrink: 0;
  width: 264px;
  height: 264px;
  border-radius: 24px;
  overflow: hidden;
  background: #fff;
}

.hero__qr img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero__scroll {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 19px;
  align-self: center;
  margin-top: auto;
  padding-top: 48px;
  color: #fff;
  font-family: 'Averia Serif Libre', Georgia, serif;
  font-size: clamp(1.25rem, 1.67vw, 2rem);
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}

.hero__scroll img {
  width: 28px;
  height: 28px;
}

.hero__scroll:hover {
  opacity: 0.92;
}

.hero__scroll:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 3px;
}

@media (max-width: 1100px) {
  .hero__inner {
    padding: 40px 32px 40px;
  }

  .hero__top {
    gap: 32px;
  }

  .hero__qr {
    width: 200px;
    height: 200px;
  }
}

@media (max-width: 768px) {
  .hero__inner {
    padding: 32px 24px 32px;
  }

  .hero__top {
    flex-direction: column;
    gap: 32px;
  }

  .hero__copy {
    max-width: none;
  }

  .hero__title {
    margin-bottom: 20px;
  }

  .hero__subtitle {
    margin-bottom: 28px;
  }

  .hero__qr {
    width: 180px;
    height: 180px;
  }
}

@media (max-width: 480px) {
  .hero__stores {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,iDAAiD;EACjD,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".hero {\n  position: relative;\n  width: 100%;\n  min-height: 80vh;\n  min-height: 80dvh;\n  overflow: hidden;\n  color: #fff;\n}\n\n.hero__backdrop {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.hero__bg-image {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.hero__gradient {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0.2) 0%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.hero__inner {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 80vh;\n  min-height: 80dvh;\n  max-width: 1920px;\n  margin: 0 auto;\n  padding: 56px 56px 48px;\n  box-sizing: border-box;\n}\n\n.hero__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 48px;\n}\n\n.hero__copy {\n  flex: 1;\n  min-width: 0;\n  max-width: 722px;\n  padding-left: 0;\n}\n\n.hero__title {\n  margin: 0 0 32px;\n  font-family: 'Averia Serif Libre', Georgia, serif;\n  font-size: clamp(2.5rem, 3.75vw, 4.5rem);\n  font-weight: 400;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  color: #fff;\n}\n\n.hero__subtitle {\n  margin: 0 0 40px;\n  max-width: 580px;\n  font-family: 'Inter', system-ui, sans-serif;\n  font-size: clamp(1rem, 1.25vw, 1.5rem);\n  font-weight: 500;\n  line-height: 1.35;\n  color: #fff;\n  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.5);\n}\n\n.hero__stores {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.hero__qr {\n  flex-shrink: 0;\n  width: 264px;\n  height: 264px;\n  border-radius: 24px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.hero__qr img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.hero__scroll {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 19px;\n  align-self: center;\n  margin-top: auto;\n  padding-top: 48px;\n  color: #fff;\n  font-family: 'Averia Serif Libre', Georgia, serif;\n  font-size: clamp(1.25rem, 1.67vw, 2rem);\n  font-weight: 400;\n  line-height: normal;\n  text-decoration: none;\n  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n  white-space: nowrap;\n}\n\n.hero__scroll img {\n  width: 28px;\n  height: 28px;\n}\n\n.hero__scroll:hover {\n  opacity: 0.92;\n}\n\n.hero__scroll:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 3px;\n}\n\n@media (max-width: 1100px) {\n  .hero__inner {\n    padding: 40px 32px 40px;\n  }\n\n  .hero__top {\n    gap: 32px;\n  }\n\n  .hero__qr {\n    width: 200px;\n    height: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero__inner {\n    padding: 32px 24px 32px;\n  }\n\n  .hero__top {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .hero__copy {\n    max-width: none;\n  }\n\n  .hero__title {\n    margin-bottom: 20px;\n  }\n\n  .hero__subtitle {\n    margin-bottom: 28px;\n  }\n\n  .hero__qr {\n    width: 180px;\n    height: 180px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero__stores {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
